import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_mnk7hh4t6b: FaireBrandEntity = {
  token: "b_mnk7hh4t6b",
  type: "brand",
  name: "SaltWTR",
  avatarUrl:
    "https://cdn.faire.com/fastly/c04d0008a2e9204f833f491a7f1ebbcdb7fd3216ba8992b648868345250fdecb.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/ed034a13f0f7ae8e76ad5916cdef79a911f2e5f293187cb48f817f75b2bae41e.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c04d0008a2e9204f833f491a7f1ebbcdb7fd3216ba8992b648868345250fdecb.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/ed034a13f0f7ae8e76ad5916cdef79a911f2e5f293187cb48f817f75b2bae41e.png",
  location: "Cumming, GA, USA",
  minimumOrderDollars: 62,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "SaltWTR products are made for everyday wellness, for everybody.  SaltWTR is a dual function electrolyte powder, providing the benefits of daily electrolytes with powerful functional ingredients and trace minerals to replenish and support your body daily.  Made with clean ingredients – including Kalahari Desert Salt, one of the purest salts on earth!  Kalahari Desert Salt has no microplastics, naturally rich in minerals, unrefined, clean flavor, and sustainably harvested.  \n\nNot only is sustainability an important part of our mission but we also have a meaningful impact on our surrounding communities.  ",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:44.409Z",
    importedBy: "entity-db-cli",
  },
};
